import * as React from "react";
import { ChevronRight, ChevronLeft } from "lucide-react";
import { Button } from "../../components/ui/button";
import { useChartGroupContext } from "./useChartGroupContext";
export const TimeRangeButtons = () => {
    const cls = "absolute inset-y-0 m-auto z-10 p-0 rounded-full w-6 h-6";
    const { visibleRange, setVisibleRange } = useChartGroupContext();
    const backward = () => {
        const [from, to] = visibleRange;
        const newFrom = new Date(2 * from.valueOf() - to.valueOf() - 1);
        const newTo = new Date(from.valueOf() - 1);
        setVisibleRange([newFrom, newTo]);
    };
    const forward = () => {
        const [from, to] = visibleRange;
        const newFrom = new Date(to.valueOf() + 1);
        const newTo = new Date(2 * to.valueOf() - from.valueOf() + 1);
        setVisibleRange([newFrom, newTo]);
    };
    React.useEffect(() => {
        const handler = (ev) => {
            if (ev.ctrlKey && ev.shiftKey) {
                switch (ev.key.toLowerCase()) {
                    case "arrowdown":
                        backward();
                        ev.preventDefault();
                        break;
                    case "arrowup":
                        forward();
                        ev.preventDefault();
                        break;
                }
            }
        };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [visibleRange]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: `${cls} left-4`, size: "icon", variant: "outline", onClick: backward },
            React.createElement(ChevronLeft, { className: "w-4 h-4" })),
        React.createElement(Button, { className: `${cls} right-4`, size: "icon", variant: "outline", onClick: forward },
            React.createElement(ChevronRight, { className: "w-4 h-4" }))));
};
//# sourceMappingURL=TimeRangeButtons.js.map